import styled from 'styled-components';
import { SummaryTitleStyled } from '../SummaryTitleStyled';
import { rem } from 'polished';

export const SummaryTitleOV = styled(SummaryTitleStyled)`
    h3 {
        font-size: ${rem(40)};
    }

    p {
        font-size: ${rem(20)};
        font-weight: ${({ theme }) => theme.fontWeights.textLight};
    }
`;
